import { CheckIcon } from "native-base";
import React from "react";

export const selectProps = {
    selectedItemProps: {
        bg: "teal.100",
        endIcon: <CheckIcon size="6" />
    }
}